import { Building, Building2, Cog, DollarSign } from "lucide-react";
import React from "react";
import gathering from "../../assets/home/gathering.webp";
import { Link } from "react-router-dom";

const GatheringGalore = () => {
  return (
    <div className="relative flex flex-col items-center justify-center mb-6 mt-5 lg:mt-24">
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-contain opacity-10 w-[500px] lg:w-full md:block"
        style={{
          backgroundImage: `url(${gathering})`,
        }}
      />
      <div className="relative z-10 flex flex-col items-center gap-2 lg:gap-3 w-full">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-purple-600 max-w-4xl md:mb-5 text-center">
          Seniors and disabled persons housed through SilverTLC have a choice of
          single or shared rooms, with as needed or around-the-clock care.
        </h1>
        <h2 className="text-xl lg:text-2xl justify-center items-center text-center mb-3 text-purple-600">
          SilverTLC  partners with
        </h2>
      </div>
      {/* boxes start - now in a single row of four */}
      <div className="w-full max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-14 auto-rows-fr">
          {/* Agency Box */}
          <div className="flex flex-col items-start p-6 bg-[#F1F1F1] hover:bg-[#dddddd] transition-all ease-in-out shadow-lg rounded-lg">
            <Link to="/register" className="z-10">
              <div className="flex items-center gap-8 mb-4">
                <Building2 className="h-5 w-5 text-purple-600" />
                <p className="font-bold">Agencies</p>
              </div>
              <p className="text-gray-700">
                Managed care organizations/national health insurance agencies;
                governmental departments and agencies; hospitals and healthcare
                systems; and short/long term care/rehabilitation and mental
                health facilities.
              </p>
            </Link>
          </div>

          {/* Service Providers Box */}
          <div className="flex flex-col items-start p-6 bg-[#F1F1F1] hover:bg-[#dddddd] transition-all ease-in-out shadow-lg rounded-lg">
            <Link to="/register" className="z-10">
              <div className="flex items-center gap-3 mb-4">
                <Cog className="h-5 w-5 text-purple-600" />
                <p className="font-bold">Service Providers</p>
              </div>
              <p className="text-gray-700">
                Transportation companies; adult day care; fitness centers; as
                well as; furniture suppliers; contractors and handyman services;
                skilled nursing and home health care; as well as book keeping
                and bill pay services.
              </p>
            </Link>
          </div>

          {/* Real Estate Box */}
          <div className="flex flex-col items-start p-6 bg-[#F1F1F1] hover:bg-[#dddddd] transition-all ease-in-out shadow-lg rounded-lg">
            <Link to="/register" className="z-10">
              <div className="flex items-center gap-3 mb-4">
                <Building className="h-5 w-5 text-purple-600" />
                <p className="font-bold">Real Estate</p>
              </div>
              <p className="text-gray-700">
                Owner managers; developers; as well as; local and state housing
                authorities.
              </p>
            </Link>
          </div>

          {/* Non-Profits Box */}
          <div className="flex flex-col items-start p-6 bg-[#F1F1F1] hover:bg-[#dddddd] transition-all ease-in-out shadow-lg rounded-lg">
            <Link to="/register" className="z-10">
              <div className="flex items-center gap-3 mb-4">
                <DollarSign className="h-5 w-5 text-purple-600" />
                <p className="font-bold">Non-Profits</p>
              </div>
              <p className="text-gray-700">
                Servicing seniors and disabled populaces.
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GatheringGalore;
